import { render } from "./Generateapppassword.vue?vue&type=template&id=5294064a"
import script from "./Generateapppassword.vue?vue&type=script&lang=js"
export * from "./Generateapppassword.vue?vue&type=script&lang=js"

import "./Generateapppassword.vue?vue&type=style&index=0&id=5294064a&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__